import { Link } from "react-router-dom";

export default function PublicFooter() {
  return (
    <footer className="border-t border-slate-200 bg-slate-50 mt-20" data-testid="public-footer">
      <div className="max-w-7xl mx-auto px-4 lg:px-8 py-12 grid grid-cols-1 md:grid-cols-4 gap-8">
        <div>
          <img src="/assets/carfin-logo.png" alt="CarFin India" className="h-10 mb-3" />
          <div className="text-xs uppercase tracking-wider text-teal-700 mb-3">Red Fort Capital Finance NBFC</div>
          <p className="text-sm text-slate-600 leading-relaxed">
            Instant used car loans powered by vehicle intelligence. India's first diagnostics-led used car financing platform.
          </p>
        </div>
        <div>
          <div className="font-semibold mb-3 text-slate-900">Products</div>
          <ul className="space-y-2 text-sm text-slate-600">
            <li><Link to="/used-car-loans" className="hover:text-slate-900">Used Car Loans</Link></li>
            <li><Link to="/check-eligibility" className="hover:text-slate-900">Check Eligibility</Link></li>
            <li><Link to="/cardr-advantage" className="hover:text-slate-900">CarDr Diagnostics</Link></li>
            <li><Link to="/how-it-works" className="hover:text-slate-900">How It Works</Link></li>
            <li><Link to="/documents-required" className="hover:text-slate-900">Documents Required</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-semibold mb-3 text-slate-900">Partners</div>
          <ul className="space-y-2 text-sm text-slate-600">
            <li><Link to="/dealer-partners" className="hover:text-slate-900">Become a Dealer</Link></li>
            <li><Link to="/dsa-partners" className="hover:text-slate-900">Become a DSA</Link></li>
            <li><Link to="/about-red-fort-capital" className="hover:text-slate-900">About Red Fort Capital</Link></li>
            <li><Link to="/contact" className="hover:text-slate-900">Contact Sales</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-semibold mb-3 text-slate-900">Legal</div>
          <ul className="space-y-2 text-sm text-slate-600">
            <li><Link to="/privacy" className="hover:text-slate-900">Privacy Policy</Link></li>
            <li><Link to="/consent-policy" className="hover:text-slate-900">Consent Policy</Link></li>
            <li><Link to="/terms" className="hover:text-slate-900">Terms of Use</Link></li>
            <li><Link to="/faqs" className="hover:text-slate-900">FAQs</Link></li>
            <li><Link to="/global" className="hover:text-slate-900">Change Country</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-slate-200 py-6 text-center text-xs text-slate-500">
        © {new Date().getFullYear()} Red Fort Capital Finance NBFC. Loan approval is subject to Red Fort Capital Finance credit policy, vehicle valuation, document verification, and final underwriting approval.
      </div>
    </footer>
  );
}
